import { lazy } from 'react';

export const LandingPage = lazy(
  () => import('pages/pre-login-landing/pre-login-landing.page'),
);

export const AboutMyHealthAlbertaPage = lazy(
  () => import('pages/about/about-my-health-alberta.page'),
);

export const Home = lazy(() => import('pages/home/home.page'));

export const CareCollectionsRoutes = lazy(() =>
  import('@leagueplatform/care-collections').then((module) => ({
    default: module.CareCollectionsRoutes,
  })),
);
export const CareDiscoveryRoutes = lazy(() =>
  import('@leagueplatform/care-discovery').then((module) => ({
    default: module.CareDiscoveryRoutes,
  })),
);
export const HealthNeedPages = lazy(() =>
  import('@leagueplatform/care-collections').then((module) => ({
    default: module.HealthNeedPages,
  })),
);

export const HealthProfileRoutes = lazy(() =>
  import('@leagueplatform/health-profile').then((module) => ({
    default: module.HealthProfileRoutes,
  })),
);

export const AboutMeRoutes = lazy(() =>
  import('@leagueplatform/about-me').then((module) => ({
    default: module.AboutMeRoutes,
  })),
);

export const OnboardingRoutesWithProvider = lazy(() =>
  import('@leagueplatform/onboarding').then((module) => ({
    default: module.OnboardingRoutesWithProvider,
  })),
);

export const AchievementsPage = lazy(
  () => import('pages/achievements/achievements.page'),
);

// SDK route kept for the redesign-flag-off (old) experience; it redirects
// achievements into the My Health tab.
export const AchievementsRoutes = lazy(() =>
  import('@leagueplatform/rewards-achievements').then((module) => ({
    default: module.AchievementsRoutes,
  })),
);
